import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { EditionBenefitsRelayProps, VariantId } from '../../types';
import { getHamsKey } from '../../utils/getHamsKey';
import premiumBenefitsModalQueryParameters from './__generated__/premiumBenefitsModalQuery.graphql';
import type {
	PremiumBenefitsModalEntryPointProps,
	PremiumBenefitsModalEntryPointQueries,
} from './premium-benefits-modal';

type EntryPointParams = Pick<EditionBenefitsRelayProps<VariantId>, 'cloudId' | 'product'>;

type PremiumEditionBenefitsModalEntryPointComponent = EntryPointComponent<
	PremiumBenefitsModalEntryPointQueries,
	PremiumBenefitsModalEntryPointProps['entryPoints'],
	PremiumBenefitsModalEntryPointProps['props'],
	PremiumBenefitsModalEntryPointProps['extraProps']
>;

export const premiumEditionBenefitsModalEntryPoint: EntryPoint<
	PremiumEditionBenefitsModalEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<PremiumEditionBenefitsModalEntryPointComponent>(() => import(/* webpackChunkName: "@atlaskit-internal_edition-benefits-modal-premium-benefits-modal" */ "./premium-benefits-modal"), { moduleId: "ec4f3e93", modulePath: "../../../platform/packages/growth/edition-benefits-modal/src/ui/premium-benefits-modal/premium-benefits-modal.tsx", priority: "interaction", moduleId: 'edition-benefits-modal-premium-benefits-modal',
		}),
	getPreloadProps: ({ cloudId, product }: EntryPointParams) => ({
		queries: {
			premiumBenefitsModalQuery: {
				parameters: premiumBenefitsModalQueryParameters,
				variables: {
					cloudId,
					hamsProductKey: getHamsKey(product),
				},
			},
		},
		extraProps: {
			cloudId,
			product,
		},
	}),
});
